import AbstractClient from './AbstractClient'
import Messages from './Messages'
import Messenger from './Messenger'

/**
 *
 *
 * @class RemoteClient
 * @classdesc This is to create a remote client that communicates with a hosted client
 *
 */
class RemoteClient extends AbstractClient {
  /**
   * Constructor of RemoteClient
   * @constructor
   * @param clientWindow
   * @param hostWindow
   * @param name
   * @param debug
   */
  constructor(clientWindow, hostWindow, name, debug) {
    super(clientWindow, hostWindow, name, debug)

    this.onConnected = this.onConnected.bind(this)
    this.onDisconnected = this.onDisconnected.bind(this)
    this.messenger.addListener(Messenger.ON_CONNECTED, this.onConnected)
    this.messenger.addListener(Messenger.ON_DISCONNECTED, this.onDisconnected)
  }

  /**
   * Attempt to establish the connection a hosted client
   * It shall wait 10 seconds until declaring failure if no message received
   * @example
   *
   * myClient.connect()
   */
  connect(maxDelay = 10 * 1000) {
    return new Promise((resolve, reject) => {
      if (this.connected) {
        resolve()
      } else {
        const message = {
          type: Messages.CONNECT,
          correlationId: this.storePromisedMessage(
            () => {
              this.connected = true
              this.addMessengerListeners()
              resolve()
            },
            reject,
            maxDelay
          )
        }
        this.messenger.sendMessage(message)
      }
    })
  }

  /**
   * Attempt to remove the connection to hosted client
   * @example
   *
   * myClient.disconnect()
   */
  disconnect() {
    return new Promise((resolve, reject) => {
      if (!this.connected) {
        resolve()
      } else {
        const message = {
          type: Messages.DISCONNECT,
          correlationId: this.storePromisedMessage(
            () => {
              this.connected = false
              this.removeMessengerListeners()
              resolve()
            },
            reject
          )
        }
        this.messenger.sendMessage(message)
      }
    })
  }

  /**
   *
   * @param correlationId
   * @param success
   * @description Is called when a HostClient confirms connection to this RemoteClient
   */
  onConnected({ correlationId, error }) {
    this.clearPromisedMessage(correlationId, undefined, error)
  }

  /**
   *
   * @param correlationId
   * @param success
   * @description Is called when a HostClient confirms disconnection to this RemoteClient
   */
  onDisconnected({ correlationId, error }) {
    if (this.hasPromiseMessage(correlationId)) {
      this.clearPromisedMessage(correlationId, undefined, error)
    } else {
      this.connected = false
      this.removeMessengerListeners()
    }
  }
}

export default RemoteClient
